import { render } from "./UserAccount.vue?vue&type=template&id=439c3fea&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=ts"
export * from "./UserAccount.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-439c3fea"

export default script